import React from "react";
import {connect} from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import Collapse from "@material-ui/core/Collapse";

function SidebarItem({ depthStep = 10, depth = 0, expanded, item, access,  ...rest }) {
  var isCollapsed = true
  
  if(item.Items !== undefined && item.Items.length > 0){
    for (var i = 0; i < item.Items.length; i++){
      if(item.Items[i] !== undefined)
      {
        if (window.location.href.replace('#','') === `${window.location.protocol}//${window.location.host}${item.Items[i].route.replace('#','') }`){
          isCollapsed = false
        }
      }
    }
  }
 
  const [collapsed, setCollapsed] = React.useState(isCollapsed);
  const { label, Items, icon,route, onClick: onClickProp } = item;
  
  var openedClass = "";
  if(route === window.location.pathname || !isCollapsed){
    openedClass = "link-opened";
  }

  function toggleCollapse() {
    setCollapsed(prevValue => !prevValue);
  }

  function onClick(e) {
    if (Array.isArray(Items)) {
      toggleCollapse();
    }
    if (onClickProp) {
      onClickProp(e, item);
    }
  }

  let expandIcon;

  if (Array.isArray(Items) && Items.length) {
    expandIcon = !collapsed ? (
      <ExpandLessIcon
        className={
          "sidebar-item-expand-arrow" + " sidebar-item-expand-arrow-expanded"
        }
      />
    ) : (
      <ExpandMoreIcon className="sidebar-item-expand-arrow" />
    );
  }

  var v = access.get(item.Id.toString()) !== undefined;
  // eslint-disable-next-line radix
  if((parseInt(item.Id) || 0) === 0){
    v = true;
  }
  
  //for testing
  // v = true;

  return (
    <div>
      <ListItem
        className={`sidebar-item`}
        style={v ? {} : {display:'none'}}
        onClick={onClick}
        button
        dense
        {...rest}
      >
        <a href={route}
          style={{ paddingLeft: depth * depthStep }}
          className={`sidebar-item-content ${openedClass}`}
        >
  <span class="dot">
    <i className="material-icons">{icon}</i>
  </span>
  <div className="sidebar-item-text">{label}</div>
        </a>
        {expandIcon}
      </ListItem>
      <Collapse in={!collapsed} timeout="auto" unmountOnExit>
        {Array.isArray(Items) ? (
          <List disablePadding dense>
            {Items.map((subItem, index) => (
              <React.Fragment key={`${subItem.Id}${index}`}>
                {subItem === "divider" ? (
                  <Divider style={{ margin: "6px 0" }} />
                ) : (
                  <SidebarItem
                    depth={depth + 1}
                    depthStep={depthStep}
                    item={subItem}
                    access={access}
                  />
                )}
              </React.Fragment>
            ))}
          </List>
        ) : null}
      </Collapse>
      </div>
      
  );
}

function Sidebar({ items, depthStep, depth, expanded, access }) {
  if(access==undefined){
    return (
      <div className="side-menu__inner"></div>
        );
  }
  if(access.size > 0){
    return (
      <div className="side-menu__inner">
        <List disablePadding dense>
          {items.map((sidebarItem, index) => (
            CreateSideBar(sidebarItem, index, depthStep, depth, expanded, access)
          ))}
        </List>
      </div>
    );  
  }
  else{
    return ''
  }
}

function CreateSideBar(sidebarItem, index, depthStep, depth, expanded, access){

  return (
    <React.Fragment key={`${sidebarItem.Id}${index}`}>
      {sidebarItem === "divider" ? (
        <Divider style={{ margin: "6px 0" }} />
      ) : (
        <SidebarItem
          depthStep={depthStep}
          depth={depth}
          expanded={expanded}
          item={sidebarItem}
          access={access}
        />
      )}
    </React.Fragment>
  )
}

export default connect(
  (state) => {
      return {
          loggedInUser: state.auth.loggedInUser,
      }
  },
)(Sidebar);
